import { createSlice, isAnyOf } from "@reduxjs/toolkit";
import {
  getDistrict,
  getParticularPage,
  getNext,
  getPrevious,
  createDistrict,
  updateDistrict,
  handleSearch,
} from "./thunk";

const initialState = {
  districts: [],
  edit: false,
  district: null,
  count: null,
  pageNo: 1,
  next: null,
  previous: null,
  loading: false,
  loadingUpdated: false,
  loadingDistrict: false,
  loadingNext: false,
  showCreateModal: false,
};

export const districtSlice = createSlice({
  name: "district",
  initialState,
  reducers: {
    setShowCreateModal: (state, action) => {
      state.showCreateModal = action.payload;
    },
    goToPage: (state, { payload }) => {
      state.pageNo = payload;
    },
    districtEditSuccess: (state, action) => {
      state.edit = true;
      state.district = state.districts.find((district) => district.id === action.payload);
    },
    clearAllDistrict: (state) => {
      state.edit = false;
      state.loading = false;
      state.loadingUpdated = false;
      state.loadingDistrict = false;
      state.district = null;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(createDistrict.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(createDistrict.fulfilled, (state, action) => {
      state.loading = false;
      state.edit = false;
    });
    builder.addCase(createDistrict.rejected, (state) => {
      state.loading = false;
      state.edit = false;
    });
    builder.addCase(updateDistrict.pending, (state) => {
      state.loadingUpdated = true;
    });
    builder.addCase(updateDistrict.fulfilled, (state, action) => {
      state.loadingUpdated = false;
      state.edit = false;
    });
    builder.addCase(updateDistrict.rejected, (state) => {
      state.loadingUpdated = false;
    });
    builder.addMatcher(
      isAnyOf(
        getDistrict.pending,
        getParticularPage.pending,
        getPrevious.pending,
        getNext.pending,
        handleSearch.pending
      ),
      (state) => {
        state.loadingDistrict = true;
      }
    );
    builder.addMatcher(
      isAnyOf(
        getDistrict.fulfilled,
        getParticularPage.fulfilled,
        getPrevious.fulfilled,
        getNext.fulfilled,
        handleSearch.fulfilled
      ),
      (state, action) => {
        state.loadingDistrict = false;
        state.districts = action.payload.data;
        state.count = action.payload.totalCount;

        state.previous = action.payload.previous;
        state.next = action.payload.next;
      }
    );
    builder.addMatcher(
      isAnyOf(
        getDistrict.rejected,
        getParticularPage.rejected,
        getPrevious.rejected,
        getNext.rejected,
        handleSearch.rejected
      ),
      (state) => {
        state.loadingDistrict = false;
      }
    );
  },
});

export const { setShowCreateModal, goToPage, districtEditSuccess, clearAllDistrict } = districtSlice.actions;

export default districtSlice.reducer;
